import React, {Component} from 'react'
import {connect} from "react-redux";
import {cleanClinic,setClinicDataSelection,editClinic,filterClinicsTable,deleteClinic,
    deleteClinicHcps} from "../../../redux/actions/Tabs-Actions";
import MyTable from "../../../components/TableComponents/Table";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {adminApi} from "../../../services/ApiService";
import AlertConfirm from "../../../components/modals/Confirm";
import ClinicEditForm from "../../../components/clinic/ClinicEditForm";

class ClinicsTabConComposed extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected:null,
            isSideBarOpen: false,
            entry: null,
        }
    }

    async openSideBar(clinic){
        await this.setState({entry:clinic,isSideBarOpen:true})
        document.body.style.overflow = "hidden"
        this.forceUpdate();
    }

    componentWillUnmount() {

    }

    onSelectionChange = (selected) => {
        this.setState({selected})
        this.props.setClinicDataSelection(selected)
    }

    editClinicDetails = (clinic) => {
        this.openSideBar(clinic)
    }

    setClinicMoreFunctions = () => {
        let {t} = this.props
        return [
            {
                name: 'Edit Clinic Details',
                display: t('Clinic.table.edit_clinic_details'),
                call: (clinic => this.editClinicDetails(clinic))
            },
            {
                name: 'Edit Clinic Details',
                display: t('Clinic.table.delete_clinic'),
                call: (clinic => this.deleteClinic(clinic))
            }
        ]
    }

    async deleteClinic(clinic) {
        let {t} = this.props
        let confirm = await AlertConfirm({
            options:{
                title: t('Clinic.table.delete_clinic'),
            }},`${t('Clinic.table.delete_clinic_confirm')}`)
        if (confirm) {
            let resp = await adminApi.deleteClinic(clinic.Clinic_ID)
            let data = resp['data']
            if (resp.status >= 200){
                this.props.deleteClinic(data.Clinic_ID)
                this.props.deleteClinicHcps(data.Clinic_ID)
            }
        }

    }

    onFilterDataSelected = (filter) => {
        this.props.filterClinicsTable(Object.keys(filter)[0],Object.values(filter)[0])
    }

    getColumns = (t) => {
        return [
            {accessor: 'Clinic_Name', Header: t('Clinic.table.clinic_name'), resizable:false},
            {accessor: 'LinkedHCPs', Header: t('Clinic.table.linked_hcps'), resizable:false},
            {accessor: 'Clinic_Mail', Header: t('Clinic.table.email'), resizable:false},
            {accessor: 'Clinic_Phone_num', Header: t('Clinic.table.phone'), resizable:false},
        ]
    }

    render() {
        let {t} = this.props
        let columns = this.getColumns(t)
        let {entry,isSideBarOpen} = this.state
        return (
            <div className={'context-area'}>
                <MyTable
                    data={this.props.clinicData}
                    columns={columns}
                    initialData={this.props.initiateClinicData}
                    onSelectionChange={selected => this.onSelectionChange(selected)}
                    moreFunctions={this.setClinicMoreFunctions()}
                    onFilterDataSelected={filter => this.onFilterDataSelected(filter)}
                    hasSelection={true}
                    hasMore={true}
                    hasShowInfo={false}
                />
                {isSideBarOpen && <ClinicEditForm
                    t={e => t(e)}
                    title={t('Clinic.form.edit_Clinic')}
                    entry={entry}
                    editClinic={clinic => this.props.editClinic(clinic)}
                    isSideBarOpen={isSideBarOpen}
                    closeSideBar={() => this.setState({isSideBarOpen: false})}/>}
            </div>

        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        editClinic: clinicData => dispatch(editClinic(clinicData)),
        deleteClinic: clinicId => dispatch(deleteClinic(clinicId)),

         deleteClinicHcps: clinicId => dispatch(deleteClinicHcps(clinicId)),

        cleanClinic: () => dispatch(cleanClinic()),
        setClinicDataSelection: clinicData => dispatch(setClinicDataSelection(clinicData)),
        filterClinicsTable: (type,payload) => dispatch(filterClinicsTable(type,payload))
    };
}

const mapStateToProps = state => {
    return {
        clinicData:state.clinicTableDataReducer.clinicData,
        initiateClinicData:state.clinicTableDataReducer.initiateClinicData
    };
};


const ClinicsTab = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(ClinicsTabConComposed);

export default ClinicsTab;
